import { Component } from "react"
import PropTypes from "prop-types"
import Modal from "shared/components/modal"
import OrganizationSelectMenu from "./organization_select_menu"
import ServiceSelectMenu from "./service_select_menu"
import NewOrgForm from "../new_org_form"
import ErrorBoundary from "shared/components/error_boundary"

export default class ServiceSelect extends Component {
  state = {
    organizations: this.props.organizations,
    activeOrg: this.props.currentOrganization,
    initialOrg: this.props.currentOrganization,
    currentService: this.props.currentService,
    modalOpen: false,
  }

  closeNewOrgModal = () => {
    this.setState({ modalOpen: false })
  }

  openNewOrgModal = () => {
    this.setState({ modalOpen: true })
  }

  render() {
    return (
      <>
        <Modal
          show={this.state.modalOpen}
          closeListener={this.closeNewOrgModal}
        >
          <NewOrgForm createOrgUri={this.props.createOrgUri} />
        </Modal>
        <ErrorBoundary>
          <OrganizationSelectMenu
            activeOrg={this.state.activeOrg}
            initialOrg={this.state.initialOrg}
            createNewOrgHandler={this.openNewOrgModal}
            organizations={this.state.organizations}
            makerURI={this.props.makerURI}
          />
        </ErrorBoundary>
        <ErrorBoundary>
          <ServiceSelectMenu
            activeOrg={this.state.activeOrg}
            currentService={this.state.currentService}
            makerURI={this.props.makerURI}
            importPlanUri={this.props.importPlanUri}
            importUri={this.props.importUri}
            isAdmin={this.props.isAdmin}
          />
        </ErrorBoundary>
      </>
    )
  }
}

ServiceSelect.propTypes = {
  createOrgUri: PropTypes.string,
  createNewOrgHandler: PropTypes.func,
  currentService: PropTypes.object,
  currentOrganization: PropTypes.object,
  organizations: PropTypes.array,
  otherId: PropTypes.number,
  baseURI: PropTypes.string,
  makerURI: PropTypes.string,
  importPlanUri: PropTypes.string,
  importUri: PropTypes.string,
  isAdmin: PropTypes.bool,
}
